import * as actions from '~/actions/org';

export const defaultState = {
  org: {},
};

const orgState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.UPDATE_ORG:
      return {
        ...state,
        org: action.org,
      };
    default:
      return state;
  }
};

export default orgState;
